var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger"},[_c('div',{staticClass:"bar bar1"}),_c('div',{staticClass:"bar bar2"}),_c('div',{staticClass:"bar bar3"})])}]

export { render, staticRenderFns }